import { Box, Dialog, DialogActions, DialogContent, FormControlLabel, Radio, Stack, Typography } from '@mui/material'
import { Button } from '@mui/material'
import { observer } from 'mobx-react-lite'
import RadioIconUnchecked from '../Assets/RadioIconUnchecked.svg'
import RadioIconChecked from '../Assets/RadioIconChecked.svg'
import { ReactComponent as CreditCardIcon } from '../Assets/CreditCardIcon.svg'
import { ReactComponent as DeleteIcon } from '../Assets/BinIcon.svg'
import { storeElement } from 'GlobalStores/StoreElement'
import { useState } from 'react'
import { ReactComponent as BinDangerIcon } from '../Assets/BinDangerIcon.svg'
import { useTranslate } from 'GlobalStores/Cores/Translator/useTranslate'
import { CardHelper } from './CardHelper'
import { useCreditcardAliases } from '../Hooks/useCreditcardAliases'
import { storeCreditCardAlias } from './CreditCardAliasBox'
import { runInAction } from 'mobx'

const CreditCardAliasRow = observer(({ cardAliasNumber, cardBrand, isChecked = false, onChange = () => {}, afterAction = () => {} }) => {
    const translate = useTranslate()
    const { deleteCreditCard } = useCreditcardAliases()

    const [showConfirmationDialog, setShowConfirmationDialog] = useState(false)

    const cardBrandIcon = cardBrand => {
        return CardHelper.BrandOfCard(cardBrand)
    }

    const handleDelete = async number => {
        const callback = (success, error) => {
            if (success) {
                runInAction(() => {
                    storeElement.showCardFrontDrop = false
                })
                afterAction()
            } else {
                runInAction(() => {
                    storeElement.showCardFrontDrop = false
                })
                afterAction({ isError: true, errorMessages: [error] })
                setShowConfirmationDialog(false)
            }
        }
        setShowConfirmationDialog(false)
        runInAction(() => {
            storeElement.showCardFrontDrop = true
        })
        storeCreditCardAlias.setError([])
        await deleteCreditCard({ number, callback })
    }

    const handleConfirmationDialog = () => {
        onChange()
        setShowConfirmationDialog(true)
    }

    return (
        <Stack
            key={cardAliasNumber}
            sx={{
                border: isChecked ? '2px solid #99BCDF' : '1px solid #CCDEEF',
                borderRadius: '8px',
                padding: {
                    xs: '15px 16px',
                    md: '15px 25px'
                },
                justifyContent: 'space-between',
                flexDirection: 'row',
                alignItems: 'center',
                backgroundColor: isChecked ? '#F4F8FB' : 'white'
            }}>
            <FormControlLabel
                control={
                    <Radio
                        disableFocusRipple
                        disableRipple
                        checked={isChecked}
                        onChange={onChange}
                        icon={<img src={RadioIconUnchecked} alt="RadioIconUnchecked" />}
                        checkedIcon={<img src={RadioIconChecked} alt="RadioIconChecked" />}
                        sx={{ paddingY: '0px', paddingRight: '24px', paddingLeft: '12px' }}
                    />
                }
                label={
                    <Stack direction={'row'} gap={'16px'} alignItems={'center'}>
                        <CreditCardIcon />
                        <Typography
                            variant="body5"
                            fontSize={'16px'}
                            fontWeight={isChecked ? '700' : '400'}
                            fontFamily={'Inter, NotoSansThai'}
                            color={isChecked ? '#003B6F' : '#5A8FC3'}>
                            {cardAliasNumber}
                        </Typography>
                    </Stack>
                }
                name={cardAliasNumber}
            />
            <Stack sx={{ alignItems: 'center' }} direction={'row'} gap={'16px'}>
                {cardBrandIcon(cardBrand)}
                {cardBrand !== 'All' && (
                    <Box sx={{ cursor: 'pointer', height: '24px', width: '24px' }} onClick={() => handleConfirmationDialog(cardBrand)}>
                        <DeleteIcon />
                    </Box>
                )}
            </Stack>
            <Dialog
                fullWidth={storeElement.dynamicWidth <= 834 ? true : false}
                open={showConfirmationDialog}
                onClose={() => setShowConfirmationDialog(false)}
                sx={{ '.MuiPaper-root': { borderRadius: '12px', padding: '64px 24px' } }}>
                <DialogContent sx={{ padding: '0px' }}>
                    <Stack direction={'column'} gap={'16px'} alignItems={'center'} justifyContent={'center'}>
                        <Stack mb="32px">
                            <BinDangerIcon />
                        </Stack>
                        <Typography variant="h5" fontSize={'24px'} fontWeight={'700'} textAlign={'center'} fontFamily={'Inter, NotoSansThai'} color={'#003B6F'}>
                            {translate('are_you_sure')}
                        </Typography>
                        <Typography
                            variant="body1"
                            fontSize={'16px'}
                            fontWeight={'400'}
                            textAlign={'center'}
                            fontFamily={'Inter, NotoSansThai'}
                            color={'#003B6F'}>
                            {translate('card_remove')} {cardAliasNumber}
                        </Typography>
                    </Stack>
                </DialogContent>
                <DialogActions>
                    <Stack direction={'column'} gap={'16px'} mt="32px" justifyContent={'center'} alignItems={'center'} width={'100%'}>
                        <Button
                            variant="contained"
                            disableRipple
                            disableFocusRipple
                            disableTouchRipple
                            disableElevation
                            fullWidth={storeElement.dynamicWidth <= 834 ? true : false}
                            sx={{
                                backgroundColor: '#5A8FC3',
                                color: 'white',
                                padding: '10px 16px',
                                borderRadius: '32px',
                                '&:disabled': {
                                    backgroundColor: '#99BCDF',
                                    color: 'white'
                                }
                            }}
                            onClick={() => handleDelete(cardBrand)}>
                            <Typography variant="body1" fontSize={'20px'} fontWeight={'600'} fontFamily={'Poppins, NotoSansThai'} color="white">
                                {translate('ok')}
                            </Typography>
                        </Button>
                        <Button
                            onClick={() => setShowConfirmationDialog(false)}
                            disableRipple
                            disableFocusRipple
                            disableTouchRipple
                            disableElevation
                            sx={{
                                '&:hover': {
                                    background: 'transparent'
                                },
                                '&:active': {
                                    background: 'transparent'
                                }
                            }}>
                            <Typography
                                variant="body1"
                                color={'#003B6F'}
                                fontSize={'16px'}
                                fontWeight={'400'}
                                fontFamily={'Poppins, NotoSansThai'}
                                sx={{ textDecoration: 'underline' }}>
                                {translate('cancel')}
                            </Typography>
                        </Button>
                    </Stack>
                </DialogActions>
            </Dialog>
        </Stack>
    )
})

export default CreditCardAliasRow
